"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vue = _interopRequireDefault(require("vue"));

var _eventBus = require("@/helpers/event-bus.js");

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var apiWorkflow = _interopRequireWildcard(require("@/api/workflow"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

_vue.default.mixin({
  data: function data() {
    return {
      users: []
    };
  },
  methods: {
    // récupération des utilisateurs habilités en saisie (0), validation niveau 1 (1) et validation niveau 2 (2)
    getWorkflow: function () {
      var _getWorkflow = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(ecran) {
        var _this = this;

        var data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  idAffaire: this.affaire.affaire.id,
                  idSociete: this.affaire.affaire.id_societe,
                  idSecteurAct: this.affaire.affaire.id_secteur_act,
                  idSecteurGeo: this.affaire.affaire.id_secteur_geo,
                  status: this.affaire.affaire.status,
                  etape: this.affaire.affaire.etape
                }; // on gère le cas quand du circuit de validation pour l'écran de budge d'affaire quand la gestion mensuelle est ouverte

                if (ecran === 'budget_affaire' && this.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value) {
                  data.etape = CONST.AFFAIRE.ETAPE.BUDGET_AFFAIRE.value;
                }

                data.niveau = 0;
                _context.next = 5;
                return apiWorkflow.getUsersToNotify(data).then(function (results) {
                  _this.users.niveau0 = results;
                });

              case 5:
                data.niveau = 1;
                _context.next = 8;
                return apiWorkflow.getUsersToNotify(data).then(function (results) {
                  _this.users.niveau1 = results;
                });

              case 8:
                data.niveau = 2;
                _context.next = 11;
                return apiWorkflow.getUsersToNotify(data).then(function (results) {
                  _this.users.niveau2 = results;
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getWorkflow(_x) {
        return _getWorkflow.apply(this, arguments);
      }

      return getWorkflow;
    }(),
    // =====================================================
    // cas de la gestion mensuelle pour le bouton Valider la synthèse de gestion
    isUserCanValidateSynthese: function isUserCanValidateSynthese(etape, ecran) {
      var _this2 = this;

      var can = false;

      if (etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value && ecran === 'gestion_mensuelle') {
        // il faut que le user connect soit valideur niveau 1 ou 2 pour etre autorisé à valider la synthèse de gestion
        if (this.users.niveau2 && this.users.niveau2.length > 0) {
          can = this.users.niveau2.find(function (x) {
            return x.id === _this2.user.id;
          });
        } else if (this.users.niveau1 && this.users.niveau1.length > 0) {
          can = this.users.niveau1.find(function (x) {
            return x.id === _this2.user.id;
          });
        } else {
          can = true;
        }
      } // console.log(this.users, can)


      return can;
    },
    // verification si l'utilisateur connecté est dans la liste des utilisateurs autorisés à faire l'action demandée sur un écran spécifique
    isUserCanDoAction: function isUserCanDoAction(etape, ecran) {
      var _this3 = this;

      var can = false; // cas particulier si on est sur l'écran Budget Affaire et en Gestion Mensuelle
      // on doit pouvoir continuer à faire des saisies l'écran Budget Affaire
      // on utilise statusBudgetAffaire à la place de status pour les tests

      if (ecran === 'budget_affaire' && this.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value) {
        if ([CONST.AFFAIRE.STATUS.SLEEPING.value, CONST.AFFAIRE.STATUS.CLOSED.value, CONST.AFFAIRE.STATUS.ARCHIVED.value].includes(this.affaire.affaire.status)) {
          can = false;
        } else {
          if ([CONST.AFFAIRE.STATUS.CREATED.value, CONST.AFFAIRE.STATUS.DENIED1.value, CONST.AFFAIRE.STATUS.DENIED2.value].includes(this.affaire.affaire.statusBudgetAffaire)) {
            can = this.users.niveau0 && this.users.niveau0.find(function (x) {
              return x.id === _this3.user.id;
            });
          } else if ([CONST.AFFAIRE.STATUS.TOVALIDATE1.value].includes(this.affaire.affaire.statusBudgetAffaire)) {
            can = this.users.niveau1 && this.users.niveau1.find(function (x) {
              return x.id === _this3.user.id;
            });
          } else if ([CONST.AFFAIRE.STATUS.TOVALIDATE2.value].includes(this.affaire.affaire.statusBudgetAffaire)) {
            can = this.users.niveau2 && this.users.niveau2.find(function (x) {
              return x.id === _this3.user.id;
            });
          }
        } // cas général

      } else {
        if (etape === this.affaire.affaire.etape) {
          if ([CONST.AFFAIRE.STATUS.CREATED.value, CONST.AFFAIRE.STATUS.DENIED1.value, CONST.AFFAIRE.STATUS.DENIED2.value].includes(this.affaire.affaire.status)) {
            can = this.users.niveau0 && this.users.niveau0.find(function (x) {
              return x.id === _this3.user.id;
            });
          } else if ([CONST.AFFAIRE.STATUS.TOVALIDATE1.value].includes(this.affaire.affaire.status)) {
            can = this.users.niveau1 && this.users.niveau1.find(function (x) {
              return x.id === _this3.user.id;
            });
          } else if ([CONST.AFFAIRE.STATUS.TOVALIDATE2.value].includes(this.affaire.affaire.status)) {
            can = this.users.niveau2 && this.users.niveau2.find(function (x) {
              return x.id === _this3.user.id;
            });
          }
        }
      }

      return can;
    },
    // ==================================================================
    handleMixinAction: function handleMixinAction(workflow) {
      var _this4 = this;

      // on execute la fonction suggérée par le moteur de worfklow si elle existe
      // nottament pour faire des controles supplémentaires avant de faire la mise à jour et envoyer les notifications
      var api;

      if (typeof this[workflow.actionBefore] === 'function') {
        api = this[workflow.actionBefore](workflow);
      } else {
        api = new Promise(function (resolve) {
          resolve();
        });
      }

      this.$loader(true);
      api.then(function () {
        // on sauvegarde le status/etape actuel de l'affaire pour faire un rollback si aucune personnes est à notifier
        // C'est pour éviter d'avoir une affaire ou personne ne peut intervenir dessus car cela sous-entend que dans le
        // circuit de validation il manque du paramétrage ou qu'il manque des intervenants dans la configuration
        // de l'affaire (ex: chef de projet, conducteur de travaux, responsable de secteur ou ingénieur d'étude)
        var prevStatus = _this4.affaire.affaire.status;
        var prevEtape = _this4.affaire.affaire.etape;
        var prevStatusBudgetAffaire = _this4.affaire.affaire.statusBudgetAffaire;
        var data = {}; // cas particulier de l'écran Budget affaire si on est en gestion mensuelle
        // le status de l'affaire pour cet écran n'est plus géré sur le champ status de l'affaire mais sur le champ statusBudgetAffaire
        // c'est alors le champ statusBudgetAffaire qui gère les demandes soumettre à validation, validation, refus uniquement de l'écran Budget Affaire
        // il faut aussi indiquer à sendNotifications de rechercher les utilisateurs à notifier correspondant à l'étape de Budget Affaire et pas de Gestion mensuelle
        // donc on force l'etape à BUDGET_AFFAIRE (nb cela ne modifie pas l'etape de l'affaire)

        if (workflow.ecran === 'budget_affaire' && _this4.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value) {
          workflow.etape = CONST.AFFAIRE.ETAPE.BUDGET_AFFAIRE.value;
          workflow.message = 'Budget Affaire. ' + workflow.message; // pour un message + explicite dans l'historique

          data = {
            statusBudgetAffaire: workflow.statusBudgetAffaire
          }; // cas général pour les autres actions
        } else {
          data = {
            status: workflow.status,
            etape: workflow.etape
          };
        } // mise à jour des nouvelles données de l'affaire


        apiAffaire.update(_this4.affaire.affaire.id, data).then(function (result) {
          if (result.affectedRows > 0) {
            // envoi des notifications
            apiWorkflow.sendNotifications({
              affaire: _this4.affaire.affaire,
              workflow: workflow
            }).then(function (results) {
              _this4.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this4.affaire.affaire, {
                message: workflow.message
              }));

              _this4.$message(results.message);
            }).then(function () {
              if (typeof _this4[workflow.actionAfter] === 'function') {
                _this4[workflow.actionAfter](workflow);
              }
            }).finally(function () {
              _eventBus.EventBus.$emit('REFRESH_ROUTER'); // pour recharger la page et réactualiser les données du store

            }) // si aucune personne à notifier on restaure l'ancien status/statusBudgetAffaire/etape de l'affaire
            // et on signale l'annulation de l'action dans l'historique
            .catch(function () {
              apiAffaire.update(_this4.affaire.affaire.id, {
                status: prevStatus,
                statusBudgetAffaire: prevStatusBudgetAffaire,
                etape: prevEtape
              }).then(function () {
                _this4.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this4.affaire.affaire, {
                  message: workflow.message + '. Action annulée. Aucune personne à notifier'
                }));
              });
            });
          }
        });
      }).finally(function () {
        _this4.$loader(false);
      });
    }
  }
});